import { Card, useTheme, Typography } from "@mui/material";
import { styled } from "@mui/styles";

const StyledCard = styled(Card)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(2),
  textAlign: 'flex-start',
  color: theme.palette.secondary.main,
  marginLeft: theme.spacing(5),
  marginRight: theme.spacing(5),
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(3),
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(3),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
}));

const Impressum = () => {
    const theme = useTheme();

    return (
        <div class="centered">
            <StyledCard theme={theme} className="custom-grid">
                <Typography fontSize={20}><strong>Impressum</strong></Typography>
                <Typography fontSize={18}>Sebastian Hillert</Typography>
                <Typography fontSize={18}>Südring 2, 30966 Hemmingen</Typography>
                <Typography fontSize={18}>info@frittiwiki.de</Typography>
            </StyledCard>
        </div>
    )
}

export default Impressum;